import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Parameter, ParameterWithTitle } from '../../configurator/models/Parameter';
import { Step } from '../../configurator/models/Step';



type WorkflowState = {
    currentStep: Step;
    currentTreatments?: ParameterWithTitle[],
    currentIncludedTreatments?:Parameter[],
    promoType?:string
}

const initialState: WorkflowState = {
    currentStep: null
}

const workflowSlice = createSlice({
    name: 'workflow',
    initialState,
    reducers: {
        setCurrentStep(state, action: PayloadAction<Step>) {
            state.currentStep = action.payload;
        },
        setParameterPrice(state, action:  PayloadAction< ParameterWithTitle[] >){
            state.currentTreatments= action.payload;
        },
        setCurrentIncluded(state, action:  PayloadAction< Parameter[] >){
            state.currentIncludedTreatments= action.payload;
        },
        setPromoType(state, action:  PayloadAction< string >){
            state.promoType= action.payload;
        },
    }
});

export const workflowActions = workflowSlice.actions;
export const workflowReducer = workflowSlice.reducer;